import { RecordStepRecordingActivityRequestSchema, RecordStepRecordingActivityResponseSchema } from './record-step-recording-activity.schema';
/**
 * Record Step Recording Activity (heartbeat) Endpoint Contract
 * A lightweight ping the editor sends on a timer while the user is actively
 * working on an in_progress recording. The server measures the elapsed time
 * since the previous heartbeat (idle-capped) and folds it into the open
 * recording session, so no client-supplied duration is trusted. No-op once the
 * recording leaves in_progress.
 */ export const recordStepRecordingActivityContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/heartbeat',
    description: 'Record active editing time for an in_progress step recording via a server-clocked heartbeat',
    requestSchema: RecordStepRecordingActivityRequestSchema,
    responseSchema: RecordStepRecordingActivityResponseSchema,
    statusCodes: {
        success: 204,
        errors: {
            401: 'Unauthorized',
            404: 'Step recording not found'
        }
    }
};

//# sourceMappingURL=record-step-recording-activity.contract.js.map